import cn from 'classnames';
import { FC } from 'react';

import WheelchairIcon from '~components/ui/WheelchairIcon';

import { Seat as SeatType } from '~types';

import s from './Seats.module.css';

const SEAT_STATUS = {
  '0': s.available,
  '1': s.occupied,
  '3': s.unavailable,
  '4': s.special,
  '5': s.selected,
} as const;

type Action = 'add' | 'remove';

interface Props {
  data: SeatType;
  status: keyof typeof SEAT_STATUS;
  isCouch?: boolean;
  onClick?: (action: Action) => void;
  hideNumber?: boolean;
  gridPosition: number;
  physicalPosition: string;
}

const Seat: FC<Props> = ({
  data,
  status,
  onClick,
  hideNumber,
  gridPosition,
  isCouch,
  physicalPosition,
}) => {
  const selected = status === '5';
  const canBeClicked = ['0', '5'].includes(status);
  const seatStyle = SEAT_STATUS[status];

  return (
    <span
      data-testid={canBeClicked ? `available-seat-${physicalPosition}` : ''}
      className={cn(s.seat, seatStyle, {
        [s.seatLeft]: data?.rowTypeId === 'E',
        [s.seatRight]: data?.rowTypeId === 'S',
        [s.couch]: isCouch,
      })}
      style={{ gridColumnStart: gridPosition, gridRowStart: 1 }}
      onClick={() => {
        if (canBeClicked) {
          if (!selected) {
            onClick?.('add');
          } else {
            onClick?.('remove');
          }
        }
      }}
    >
      {!hideNumber &&
        (!isCouch ? (
          <span className={s.seatWrap}>
            <span>
              {status === '4' && (
                <span title="Necesidades especiales">
                  <WheelchairIcon />
                </span>
              )}
              {['0', '5'].includes(status) && data.seatNumber}
            </span>
          </span>
        ) : (
          <>
            <span className={s.seatWrap}>
              <span>{['0', '5'].includes(status) && data.seatNumber}</span>
            </span>
            <span className={s.seatWrap}>
              <span>{['0', '5'].includes(status) && data.seatNumber}</span>
            </span>
          </>
        ))}
    </span>
  );
};

export default Seat;
